/* unplugin-vue-components disabled */import { render } from "./ReferenceInfo3.vue?vue&type=template&id=c1b8ff66&scoped=true&ts=true"
import script from "./ReferenceInfo3.vue?vue&type=script&lang=ts"
export * from "./ReferenceInfo3.vue?vue&type=script&lang=ts"

import "./ReferenceInfo3.vue?vue&type=style&index=0&id=c1b8ff66&scoped=true&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/yunxiaobao-test/prod-yunxiaobao-com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1b8ff66"]])

export default __exports__